import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
	theme: {
		themes: {
			light: {
				primary: '#213050',
				secondary: '#bf2d3a',
				accent: '#bf2d3a'
			}
		}
	}
})
